import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ATLEAST_ONE_RECORD_MSG, CrudService, RxjsService, setRequiredValidator, SnackbarService } from '@app/shared';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import { MultiQuotationModel } from '../../models/quotation.model';

@Component({
  selector: 'app-multiple-quotation-accept-dialog',
  templateUrl: './multiple-quotation-accept-dialog.component.html',
})
export class MultipleQuotationAcceptDialogComponent implements OnInit {


  multiQuoationDialogForm!: FormGroup;
  isSubmitted: boolean = false;
  tabsList = [
    {
      dataKey: 'quotationVersionId',
      formArrayName: 'quotationDetailsArray',
      hideFormArrayAction: true,
      columns: [
        { field: 'quotationNumber', displayName: 'Quotation', type: 'input_text', className: 'col-md-5', isTooltip: true },
        { field: 'quotationStatusName', displayName: 'Status', type: 'input_text', className: 'col-md-3', isTooltip: true },
        { field: 'isAcceptQuotation', displayName: '', type: 'input_pcheckbox', className: 'col-md-2', isClickEvent: true, value: true },
        { field: 'isDeclineQuotation', displayName: '', type: 'input_pcheckbox', className: 'col-md-2', isClickEvent: true, value: true },
      ],
    }
  ]

  constructor(private rxjsService: RxjsService, public config: DynamicDialogConfig,
    public ref: DynamicDialogRef, private crudService: CrudService, private formBuilder: FormBuilder,
    private snackbarService: SnackbarService,) {
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.multiQuoationDialogForm = this.formBuilder.group({});
    this.multiQuoationDialogForm.addControl('quotationDetailsArray', new FormArray([]));
    this.config?.data?.quotations?.forEach((element: any) => {
      this.initMultiQuotationFormArray({
        quotationVersionId: element?.quotationVersionId,
        quotationNumber: element?.quotationNumber,
        isAcceptQuotation: null,
        isDeclineQuotation: null,
        monthlyFees: element?.monthlyFees,
        quotationStatusName: element?.quotationStatusName
      })
    });
  }

  initMultiQuotationFormArray(multiQuotationModel?: MultiQuotationModel) {
    let multiQuotationDetailsModel: any = new MultiQuotationModel(multiQuotationModel);
    let multiQuotationDetailsFormArray = this.formBuilder.group({});
    Object.keys(multiQuotationDetailsModel).forEach((key) => {
      multiQuotationDetailsFormArray.addControl(key, new FormControl({
        value: multiQuotationDetailsModel[key],
        disabled: (key == 'quotationVersionId' || key == 'quotationNumber' || key == 'monthlyFees' || key == 'quotationStatusName') ? true : false
      }));
    });
    multiQuotationDetailsFormArray = setRequiredValidator(multiQuotationDetailsFormArray, ["quotationVersionId", "quotationNumber"]);
    this.getMultiQuotationFormArray.push(multiQuotationDetailsFormArray);
  }

  infoText() {
    const msg = "Only one quotation can be accepted at a time.<br>Multiple quotations can be declined at a time.";
    return msg;
  }

  get getMultiQuotationFormArray(): FormArray | any {
    if (!this.multiQuoationDialogForm) return;
    return this.multiQuoationDialogForm.get(this.tabsList[0]?.formArrayName) as FormArray;
  }

  onChangeCheckbox(e: any) {
    if (e?.column?.field == 'isAcceptQuotation') {
      this.getMultiQuotationFormArray?.controls[e?.index]?.get('isDeclineQuotation')?.setValue(null);
    } else if (e?.column?.field == 'isDeclineQuotation') {
      this.getMultiQuotationFormArray?.controls[e?.index]?.get('isAcceptQuotation')?.setValue(null);
    }
  }

  btnCloseClick() {
    this.ref.close(false);
  }

  onvalidateAtleastOneRecord() {
    let findArr = this.getMultiQuotationFormArray?.getRawValue()?.filter((el: any) => el?.isAcceptQuotation || el?.isDeclineQuotation);
    return findArr?.length ? false : true;
  }

  onvalidateAccept() {
    let findArr = this.getMultiQuotationFormArray?.getRawValue()?.filter((el: any) => el?.isAcceptQuotation);
    return findArr?.length > 1 ? true : false;
  }

  onSubmitDialog() {
    this.isSubmitted = true;
    if (!this.multiQuoationDialogForm?.valid) {
      this.multiQuoationDialogForm?.markAllAsTouched();
      this.isSubmitted = false;
      return;
    } else if (!this.multiQuoationDialogForm.dirty) {
      this.snackbarService.openSnackbar("No Changes were detected");
      this.isSubmitted = false;
      return;
    } else if (this.onvalidateAtleastOneRecord()) {
      this.snackbarService.openSnackbar(ATLEAST_ONE_RECORD_MSG);
      this.isSubmitted = false;
      return;
    } else if (this.onvalidateAccept()) {
      this.snackbarService.openSnackbar("Please select only one quotation to accept");
      this.isSubmitted = false;
      return;
    }
    const filterAcceptedQuote = this.getMultiQuotationFormArray?.getRawValue()?.find((el: any) => el?.isAcceptQuotation);
    const filterDeclinedQuote = this.getMultiQuotationFormArray?.getRawValue()?.filter((el: any) => el?.isDeclineQuotation);
    let declineQuotationVersionIds: any = [];
    if (filterDeclinedQuote?.length) {
      filterDeclinedQuote?.forEach((el: any) => {
        declineQuotationVersionIds.push(el?.quotationVersionId);
      })
    }
    this.rxjsService.setFormChangeDetectionProperty(true); // Form submitt No changes snackbar prevent
    const reqObj = {
      acceptArr: filterAcceptedQuote,
      declineQuotationVersionIds: declineQuotationVersionIds?.toString(),
    }
    this.ref.close(reqObj);
  }
}
